<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-data-table
                :headers="headers"
                v-model="selected"
                :items="items"
                :options.sync="options"
                :footer-props="footerProps"
                :server-items-length="totalItems"
                :loading="loading"
                :no-data-text="no_data_text"
                :mobile-breakpoint="mobileBreakpoint"
                :show-select="showSelect"
                item-key="id"
                class="elevation-1"
        >
            <!-- Set custom header icons -->
            <template v-slot:header.billable="{ header }">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <i v-on="on" class="material-icons">money</i>
                    </template>
                    <span> {{ $t('workHours.billable_hours') }}</span>
                </v-tooltip>
            </template>
            <template v-slot:header.invoiced="{ header }">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <i v-on="on" class="material-icons">menu_book</i>
                    </template>
                    <span> {{ $t('workHours.invoiced_hours') }}</span>
                </v-tooltip>
            </template>
            <template v-slot:header.paid="{ header }">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <i v-on="on" class="material-icons">account_balance_wallet</i>
                    </template>
                    <span> {{ $t('workHours.paid_hours') }}</span>
                </v-tooltip>
            </template>

            <!--Add chip element to color and background_color column-->
            <template v-slot:item.color="{ item }">
                <slot name="color_pill"
                      v-bind:item="item"
                      col_name="color"
                ></slot>
            </template>
            <template v-slot:item.background_color="{ item }">
                <slot name="color_pill"
                      v-bind:item="item"
                      col_name="background_color"
                ></slot>
            </template>

            <!--Add edit/delete buttons to actions column -->
            <template v-slot:item.actions="{ item }">
                <slot name="actions"
                      v-bind:item="item"
                ></slot>
            </template>

            <!-- Add state toggle to state column-->
            <template v-slot:item.state="{ item }">
                <slot name="state_toggle"
                      v-bind:item="item"
                ></slot>
            </template>

            <!-- Add avatar icon to icon column -->
            <template v-slot:item.avatar="{ item }">
                <slot name="avatar"
                      v-bind:item="item.name"
                ></slot>
            </template>

            <!-- Add icons to show on enabled/disabled payment options -->
            <template v-slot:item.billable="{ item }">
                <slot name="billable"
                      v-bind:item="item"
                ></slot>
            </template>
            <template v-slot:item.invoiced="{ item }">
                <slot name="invoiced"
                      v-bind:item="item"
                ></slot>
            </template>
            <template v-slot:item.paid="{ item }">
                <slot name="paid"
                      v-bind:item="item"
                ></slot>
            </template>

        </v-data-table>
    </div>
</template>

<script>
    import ConfirmActionDialog from '../components/ConfirmActionDialog.vue'

    export default {
        components: {
            ConfirmActionDialog
        },
        props: {
            enableSearch: {type: Boolean, default: false},
            loading: {type: Boolean, default: false},
            headers: {type: Array},
            items: {type: Array},
            totalItems: {type: Number},
            itemsPerPageOptions: {type: Array, default: () => [5, 10, 20, -1]},
            page: {type: Number, default: 1},
            isDescending: {type: Boolean, default: false},
            sortByColumn: {type: String, default: '0'},
            mobileBreakpoint: {type: Number, default: 600},
            selectedItems: {type: Array},
            showSelect: {type: Boolean, default: true}
        },
        data() {
            return {
                loadingText: "Loading",
                selected: [],
                options: {
                    page: this.page,
                    itemsPerPage: this.itemsPerPageOptions[0],
                    sortBy: this.sortByColumn ? [this.headers[this.sortByColumn].value] : [],
                    sortDesc: [this.isDescending],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false
                },
                footerProps: {
                    'items-per-page-options': this.itemsPerPageOptions,
                    'items-per-page-text': `${this.$t('datatable.items_per_page')}`,
                },
                no_data_text: `${this.$t('datatable.no_available_data')}`,
                state_switch: true,
            }
        },
        watch: {
            options: {
                handler(val) {
                    this.$emit('options-changed', val);
                },
                deep: true,
            },
            selected: {
                handler(val) {
                    this.$emit('selected-changed', val);
                }
            },
            selectedItems: {
                handler(val) {
                    if (this.selected !== val) {
                        this.selected = val;
                    }
                }
            }
        },
        methods: {
            editItem(item) {
                this.$emit('editItem', item);
            },
            deleteItem(item) {
                this.$emit('deleteItem', item);
            },
        },
    };
</script>
